
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions/[slug]",
      function () {
        return require("private-next-pages/questions/[slug]/index.tsx");
      }
    ]);
  